<ng-lottie [options]="animation"></ng-lottie>
<p>{{'jobboard.views.errors.404.not-found' | transloco}}</p>
<div class="text-center mt-3">
  <button class="ct-btn ct-btn-primary" [routerLink]="['/']">
    {{'jobboard.views.errors.404.back-btn' | transloco}}
  </button>
</div>